import React from 'react';
import EnhancedLineChart from './EnhancedLineChart';
import { EnhancedLineChartProps } from './EnhancedLineChart.types';

const EnhancedLineChartWithV2 = EnhancedLineChart as React.FC<
    EnhancedLineChartProps & { fixedSpacingV2?: boolean }
>;

/** V2 line chart entry point (AgenticRightPanel). Filter Reset/Select All live in EnhancedLineChart. */
const EnhancedLineChartV2: React.FC<EnhancedLineChartProps> = (props) => (
    <EnhancedLineChartWithV2 {...props} fixedSpacingV2 showFilters={props.showFilters ?? true} />
);

export default EnhancedLineChartV2;
